import { Inject, Injectable, Provider, inject } from '@angular/core';
import { ApiService } from './api.service';
import { map, Subject, tap } from 'rxjs';
import { SnackbarService } from './snackbar-psa.service';  // Use SnackbarService instead of AppSnackbarComponent
import { ApiFluxService } from './api-flux.service';

@Injectable({
  providedIn: 'root'
})
export class CrudFluxService<T> {

  constructor(
    @Inject('endpoint') protected endpoint: string,
    @Inject(ApiFluxService) protected readonly api: ApiFluxService,
    @Inject(SnackbarService) protected readonly snackbar: SnackbarService, // Inject SnackbarService here
  ) { }

  read(id: number | string) {
    return this.api.get<T>(`${this.endpoint}/${id}`).pipe(
        map(({ secondResponse }) => secondResponse.body)
    );
  }


  save(model: any, id?: number | string) {
    let saved: Subject<T> = new Subject<T>();
    let url = this.endpoint;
    if (id) {
      url += `/${id}`;
      this.api.put<T>(url, model).pipe(
        tap(([firstValue, secondValue]:any) => {
          console.log("Prima risposta:", firstValue);
          console.log("Seconda risposta:", secondValue);
        })
      ).subscribe({
        next: value => saved.next(value),
        complete: () => this.snackbar.open('Dati salvati con successo!', 'close')
      });
    } else {
      this.api.post<T>(url, model).pipe(
        map(({ secondResponse }) => secondResponse.body)
      ).subscribe({
        next: (value:any) => {
          if (value.statusCode === 200) {
              saved.next(value);
              this.snackbar.open('Operazione effettuata con successo!', 'close');
          } else {
              saved.next(value);
              this.snackbar.open(`Errore: ${value.message}`, 'close');
          }
        },
        complete: () => {}
      });
    }
    return saved.asObservable();
  }

  delete(id: number | string) {
    let deleted: Subject<any> = new Subject<any>();
    this.api.delete(`${this.endpoint}/${id}`).subscribe({
      next: (value) => {
        deleted.next(value);
      },
      complete: () => this.snackbar.open('Dati eliminati con successo!', 'close')
    })

    return deleted;
  }

}

export function provideCrudService<T>(
  endpoint: string,
  snackbar: SnackbarService,  // Inject SnackbarService in factory function
): Provider[] {
  return [
    {
      provide: createTokenCrudServiceInstance(endpoint),
      useFactory: () => new CrudFluxService<T>(
        endpoint,
        inject(ApiFluxService),
        snackbar
      ),
    }
  ]
}

export function createTokenCrudServiceInstance(endpoint: string) {
  return `${endpoint}-crud-service`;
}
